import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLieu } from "../api/lieuxApi";
import { queryKeys } from "../lib/queryKeys";

export function useDeleteLieu() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteLieu(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
    },
  });
}
